import { render, staticRenderFns } from "./FieldConf.vue?vue&type=template&id=2d4b556b&scoped=true&"
import script from "./FieldConf.vue?vue&type=script&lang=js&"
export * from "./FieldConf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4b556b",
  null
  
)

export default component.exports